module.exports = __webpack_public_path__ + "static/KyraLee-ecc56f150b7ad8c3fb6b64ff282b20b2.jpg";